import { get } from 'lodash';
import i18next from 'i18next';

import { normalizeKeys } from '@commons/Excels/utils';
import normalizeStringValue from '@commons/utils/normalizeStringValue';

const SHEET = {
  id: 'entities',
  name: 'Ingrédients',
};

const COLUMN_IDS = {
  CATEGORY: 'category',
  ID: 'id',
  NAME: 'name',
  UNIT: 'unit',
  COST: 'cost',
  IS_STRATEGIC: 'isStrategic',
};

const HIDDEN_SHEET_CATEGORY = {
  ID: 'categories',
  NAME: 'Catégories',
};

const HIDDEN_CATEGORY_COLUMN_ID = {
  NAME: 'name',
};

const getHiddenSheetCategory = () => ({
  SHEET: {
    ID: 'categories',
    NAME: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.CATEGORIES_SHEET_NAME'),
  },
  COLUMN_ID: {
    NAME: 'name',
  },
  NORMALIZE_COLUMN_ID: {
    NAME: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.CATEGORY_COLUMN'),
    ),
  },
});

const getHiddenSheetAllergen = () => ({
  SHEET: {
    ID: 'allergens',
    NAME: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.ALLERGENS_SHEET_NAME'),
  },
  COLUMN_ID: {
    NAME: 'name',
    ID: 'id',
  },
  NORMALIZE_COLUMN_ID: {
    ID: 'id',
    NAME: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.ALLERGENS_COLUMN'),
    ),
  },
});

const getSheetConfig = () => {
  const columns = {
    NAME: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.NAME_COLUMN'),
    CATEGORY: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.CATEGORY_COLUMN'),
    ID: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.ID_COLUMN'),
    UNIT: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.UNIT_COLUMN'),
    COST: i18next.t(
      '_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.COST_EXCLUDING_TAXES_COLUMN',
    ),
    IS_STRATEGIC: i18next.t(
      '_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.IS_STRATEGIC_COLUMN',
    ),
    IS_EDIBLE: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.IS_EDIBLE_COLUMN'),
  };

  const normalizedColumns = normalizeKeys(columns);

  return {
    SHEET: {
      id: 'entities',
      name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENTS_SHEET_NAME'),
    },
    COLUMN_ID: {
      CATEGORY: 'category',
      ID: 'id',
      NAME: 'name',
      UNIT: 'unit',
      COST: 'cost',
      IS_STRATEGIC: 'isStrategic',
      IS_EDIBLE: 'isEdible',
    },
    COLUMNS_CONFIG: normalizedColumns,
  };
};

const getNormalizedColumnIds = () => ({
  ID: { key: 'id', normalizedKey: 'id' },
  NAME: {
    key: 'name',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.NAME_COLUMN'),
    ),
  },
  UNIT: {
    key: 'unit',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.UNIT_COLUMN'),
    ),
    mappingFn: (row, normalizedKey) => {
      const value = get(row, normalizedKey, '');

      return value === i18next.t('GENERAL.UNIT') ? 'unit' : value;
    },
  },
  CATEGORY: {
    key: 'category',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.CATEGORY_COLUMN'),
    ),
  },
  COST: {
    key: 'cost',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.COST_EXCLUDING_TAXES_COLUMN'),
    ),
    mappingFn: (row, normalizedKey) => {
      const value = get(row, normalizedKey, 0);

      return value >= 0 ? value : null;
    },
  },
  IS_STRATEGIC: {
    key: 'isStrategic',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.IS_STRATEGIC_COLUMN'),
    ),
    mappingFn: (row, normalizedKey) => {
      const value = get(row, normalizedKey, false);

      return value === i18next.t('GENERAL.YES').toUpperCase() ? true : false;
    },
  },
  IS_EDIBLE: {
    key: 'isEdible',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.IS_EDIBLE_COLUMN'),
    ),
    mappingFn: (row, normalizedKey) => {
      const value = get(row, normalizedKey, false);

      return value === i18next.t('GENERAL.YES').toUpperCase() ? true : false;
    },
  },
});

export default {
  SHEET,
  COLUMN_IDS,
  HIDDEN_SHEET_CATEGORY,
  HIDDEN_CATEGORY_COLUMN_ID,
  getSheetConfig,
  getHiddenSheetCategory,
  getHiddenSheetAllergen,
  getNormalizedColumnIds,
};
